import { GetStaticProps, NextPage } from 'next';

import Layout from '~components/ui/Layout';
import { getFromAPI } from '~utils/api/common';
import normalizeCinemasInComplex, {
  NormalizedCinemasInComplex,
} from '~utils/normalizers/normalizeCinemaInComplex';

import { Cinema } from '~types';

import CinemasDetail from '../../components/CinemasDetail';

interface GSProps {
  cinemas: NormalizedCinemasInComplex[];
}

export const getStaticProps: GetStaticProps<GSProps> = async () => {
  const cinemas = await getFromAPI<Cinema[]>('/cinemas');

  return {
    props: {
      cinemas: normalizeCinemasInComplex(cinemas),
    },
    revalidate: 60 * 60 * 24, // 1 vez al dia
  };
};

const Cinemas: NextPage<{ cinemas: Required<Cinema>[] }> = ({ cinemas }) => {
  return (
    <Layout meta={{ title: 'Complejos Citicinemas' }} headerType="opaque">
      <div className="container">
        <div className="hero">
          <h1 className="h2 lg:big-title">Complejos</h1>
          <p>Conoce los diferentes cines que tenemos para tu comodidad.</p>
        </div>
        {cinemas.map((cinema) => (
          <CinemasDetail data={cinema} key={cinema.id} />
        ))}
      </div>
    </Layout>
  );
};

export default Cinemas;
